




















































import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({})
export default class TwismLogo extends Vue {
  @Prop({ default: '99' }) readonly width?: string;
  @Prop({ default: '24' }) readonly height?: string;
}
